import { getAnswerByQuestion, listConversations } from '../util/api';
import { buildAiLanguagePayload } from '../util/aiLanguage';
export const FETCH_ANSWER_BY_QUESTION_REQUEST = 'app/ai/FETCH_ANSWER_BY_QUESTION_REQUEST';
export const FETCH_ANSWER_BY_QUESTION_SUCCESS = 'app/ai/FETCH_ANSWER_BY_QUESTION_SUCCESS';
export const FETCH_CONVERSATIONS_REQUEST = 'app/ai/FETCH_CONVERSATIONS_REQUEST';
export const FETCH_CONVERSATIONS_SUCCESS = 'app/ai/FETCH_CONVERSATIONS_SUCCESS';
export const CLEAR_CONVERSATIONS = 'app/ai/CLEAR_CONVERSATIONS';
export const initialState = {
  answer: null,
  conversations: [],
};

const resolveRequestLocale = (params = {}) => {
  const explicitLocale = String(params.locale || '').trim();
  if (explicitLocale) return explicitLocale;

  const rawLanguage = String(
    params.chatLanguage || params.conversationPreferredLanguage || params.preferredLanguage || ''
  )
    .trim()
    .toLowerCase();

  if (rawLanguage === 'gr' || rawLanguage === 'el' || rawLanguage.startsWith('el-')) return 'el-GR';
  if (rawLanguage === 'de' || rawLanguage.startsWith('de-')) return 'de';
  if (rawLanguage === 'ar' || rawLanguage.startsWith('ar-')) return 'ar';
  if (rawLanguage === 'en' || rawLanguage.startsWith('en-')) return 'en';
  return 'en';
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ANSWER_BY_QUESTION_REQUEST:
      return { ...state };
    case FETCH_ANSWER_BY_QUESTION_SUCCESS:
      return { ...state, answer: payload };
    case FETCH_CONVERSATIONS_REQUEST:
      return { ...state };
    case FETCH_CONVERSATIONS_SUCCESS:
      return { ...state, conversations: payload };
    case CLEAR_CONVERSATIONS:
      return { ...state, conversations: [] };
    default:
      return state;
  }
}
export const fetchAnswerByQuestionRequest = () => ({
  type: FETCH_ANSWER_BY_QUESTION_REQUEST,
});
export const fetchAnswerByQuestionSuccess = payload => ({
  type: FETCH_ANSWER_BY_QUESTION_SUCCESS,
  payload,
});
export const fetchConversationsRequest = () => ({
  type: FETCH_CONVERSATIONS_REQUEST,
});
export const fetchConversationsSuccess = payload => ({
  type: FETCH_CONVERSATIONS_SUCCESS,
  payload,
});
export const clearConversations = () => ({
  type: CLEAR_CONVERSATIONS,
});
export const fetchAnswerByQuestionData = state => {
  return {
    answer: state.ai.answer,
  };
};

const normalizeAnswerPayload = payload => {
  if (!payload || typeof payload !== 'object') {
    return payload || null;
  }

  if (payload.answer && typeof payload.answer === 'object') {
    return payload.answer;
  }

  if (payload.data && typeof payload.data === 'object') {
    if (payload.data.answer && typeof payload.data.answer === 'object') {
      return payload.data.answer;
    }
    return payload.data;
  }

  return payload;
};

export const fetchAnswerByQuestion = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchAnswerByQuestionRequest());
  try {
    const state = getState();
    const currentUser = state?.user?.currentUser;
    const preferredLang = currentUser?.attributes?.profile?.protectedData?.preferredLang;
    const languagePayload = buildAiLanguagePayload({
      preferredLang,
      appLocale: resolveRequestLocale(params),
      messageText: params?.question,
    });
    const requestPayload = {
      ...languagePayload,
      ...params,
    };
    const raw = await getAnswerByQuestion({
      ...requestPayload,
      locale: resolveRequestLocale(requestPayload),
    });
    const answer = normalizeAnswerPayload(raw);
    dispatch(fetchAnswerByQuestionSuccess(answer));
    return answer;
  } catch (error) {
    // Re-throw the error so it can be handled by the component
    throw error;
  }
};
export const fetchConversations = (params = {}) => async dispatch => {
  dispatch(fetchConversationsRequest());
  try {
    const { conversations = [] } =
      (await listConversations({
        ...params,
        locale: resolveRequestLocale(params),
      })) || {};
    dispatch(fetchConversationsSuccess(conversations));
    return conversations;
  } catch (error) {}
};
